module.exports = __webpack_public_path__ + "img/logo.ddc79f53.png";